import { styled } from '@mui/material/styles';

/**
 * One row in a stacked list of people (document viewers, signer lists).
 *
 * The separator/spacing rules are relational — a row draws a bottom rule unless
 * it is last, and gains top margin only when it follows another row — so they
 * stay as `&:not(:last-child)` / `& + &` rather than becoming props.
 *
 * Token migration: `$color-neutrals-solid-5` (#DAE3E5) → `grey[90]` (#D6E0E2).
 */
export const Wrapper = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'auto 1fr',
  gap: '0.5rem',
  alignItems: 'center',
  paddingBottom: '0.5rem',

  '&:not(:last-child)': {
    borderBottom: `1px solid ${theme.palette.grey[90]}`,
  },

  '& + &': {
    marginTop: '0.5rem',
  },
}));

export const Content = styled('div')({
  minWidth: 0,
});

export const NameWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '0.5rem',
});

export const NameStack = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '0.25rem',
  minWidth: 0,
});

export const Name = styled('div')({
  minWidth: 0,
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
});
